module.exports = __webpack_public_path__ + "media/react/assets/imgs/notfollowing-5b405d60bc74cbc79640ad8e172993ea.png";